import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["calculationSidebar"];

  connect() {
    document.addEventListener(
      "open-calculation-sidebar",
      this.openCalculationSidebar.bind(this)
    );
    document.addEventListener("click", this.handleClickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener(
      "open-calculation-sidebar",
      this.openCalculationSidebar.bind(this)
    );
    document.removeEventListener("click", this.handleClickOutside.bind(this));
  }

  openCalculationSidebar() {
    this.calculationSidebarTarget.classList.remove("translate-x-full");
    this.calculationSidebarTarget.classList.add("translate-x-0");
    // Prevent the click that triggered the open from also closing it
    this.shouldIgnoreNextClick = true;
    setTimeout(() => {
      this.shouldIgnoreNextClick = false;
    }, 0);
  }

  closeCalculationSidebar() {
    this.calculationSidebarTarget.classList.remove("translate-x-0");
    this.calculationSidebarTarget.classList.add("translate-x-full");
    // Dispatch event so WageChart can reset bar highlighting
    document.dispatchEvent(new CustomEvent("close-calculation-sidebar"));
  }

  handleClickOutside(event) {
    // Ignore the click that triggered the open
    if (this.shouldIgnoreNextClick) return;

    // Check if sidebar is open
    const isOpen =
      this.calculationSidebarTarget.classList.contains("translate-x-0");

    // If sidebar is not open, do nothing
    if (!isOpen) return;

    // Check if click is outside the sidebar
    // Use multiple methods to check since Vue components might not be direct children
    const isClickInsideSidebar =
      this.calculationSidebarTarget.contains(event.target) ||
      event.target.closest(".calculation-sidebar") !== null;

    // If click is outside sidebar, close it
    if (!isClickInsideSidebar) {
      this.closeCalculationSidebar();
    }
  }
}
